<template>
  <div
    v-if="visible"
    class="fdd-loading-mask"
    :class="{ 'is-fullscreen': fullscreen }"
    :style="zIndex && `z-index: ${zIndex}`"
  >
    <div class="fdd-loading">
      <img class="fdd-loading-icon" src="@img/userCenter/loading.png" alt="加载中" />
      <p v-if="message" class="fdd-loading-msg">{{ message }}</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'LoadingBox',
    props: {
      // 加载消息
      message: {
        type: String,
        default: ''
      },

      // 是否可见
      visible: {
        type: Boolean,
        default: true
      },

      zIndex: {
        type: [Number, String]
      },

      // 是否全屏
      fullscreen: {
        type: Boolean,
        default: true
      }
    }
  }
</script>

<style lang="less" scoped>
  .fdd-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 80%;
    text-align: center;

    &-mask {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 11;
      background: rgba(#fff, 0.8);
      user-select: none;

      &.is-fullscreen {
        z-index: 9999;
      }
    }

    &-icon {
      height: 40px;
      width: 40px;
      margin: 0 auto;
      animation: rolling 0.8s linear infinite;
    }

    &-msg {
      color: #989da8;
      margin-top: 16px;
    }
  }
</style>
